'use client';

import { useEffect } from 'react';

import { ToastAction, useToast } from '@quick/components/Toaster';

import { useAppTranslation } from '@/app/i18n/client';
import { ReactComponent as Refresh } from '@/assets/refresh.svg';
import { envs } from '@/layers/core/data/const';
import { useFetch } from '@/layers/core/deal/services/useFetch';

export function VersionAlert() {
  const { t } = useAppTranslation('common');

  const { data } = useFetch<{ hash: string }>(
    { url: '/healthcheck/app_version' },
    {
      refreshInterval: 300_000, // Check every 5 minutes
      dedupingInterval: 300_000,
    }
  );

  const { toast } = useToast();

  const isOutdated = data && envs.pwaVersion && data.hash !== envs.pwaVersion;

  useEffect(() => {
    if (isOutdated) {
      toast({
        title: t('versionAlert.title'),
        description: t('versionAlert.message'),
        variant: 'info',
        action: (
          <ToastAction
            altText={t('versionAlert.refreshButton')}
            onClick={handleRefresh}
          >
            <Refresh className="size-6" aria-hidden="true" />
          </ToastAction>
        ),
      });
    }
  }, [isOutdated, t, toast]);

  return null;
}

const handleRefresh = () => {
  window.location.reload();
};
